import { Injectable } from '@angular/core';
import { TreeNode } from './models/TreeNode';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PresetTreeElementsService {
  readonly rootId = 0;

  private presetTreeElements: TreeNode[] = [
    {
      item_name: 'NAVBAR.LOGGER_LIST',
      is_authorized: true,
      is_end_type: true,
      isPreSetElement: true,
      id: 'loggers',
      parent_id: this.rootId,
      icon: 'logger',
      pointingUrl: '/logger',
    },
    {
      item_name: 'NAVBAR.GROUP_POLICIES',
      is_authorized: true,
      is_end_type: true,
      isPreSetElement: true,
      id: 'policies',
      parent_id: this.rootId,
      icon: 'policy',
      pointingUrl: '/tree/gp',
      always_available: true,
    },
    {
      item_name: 'NAVBAR.REPORTS',
      is_authorized: false,
      is_end_type: true,
      isPreSetElement: true,
      id: 'reports',
      parent_id: this.rootId,
      icon: 'document',
      pointingUrl: '/reports',
      always_available: true,
    },
    {
      item_name: 'NAVBAR.GIVEN_PERMISSIONS',
      is_authorized: true,
      is_end_type: true,
      isPreSetElement: true,
      id: 'policies-permissions',
      parent_id: this.rootId,
      icon: 'user_policy',
      pointingUrl: '/tree/gp/permissions',
    },
    {
      item_name: 'NAVBAR.INVOICES',
      is_authorized: false,
      is_end_type: false, // this is changed in TreeNodeComponent hasChildren
      isPreSetElement: true,
      id: 'invoice',
      parent_id: this.rootId,
      icon: 'file',
      pointingUrl: '/invoice',
      presetChildren: of([
        {
          item_name: 'NAVBAR.CUSTOMERS',
          is_authorized: true,
          is_end_type: true,
          isPreSetElement: true,
          id: 'customer',
          parent_id: 'invoice',
          icon: 'user',
          pointingUrl: '/organization/customer',
        },
        {
          item_name: 'NAVBAR.INVOICES_TEMPLATES',
          is_authorized: true,
          is_end_type: true,
          isPreSetElement: true,
          id: 'invoice-templates',
          parent_id: 'invoice',
          icon: 'certificate',
          pointingUrl: '/invoice/templates',
        },
        {
          item_name: 'NAVBAR.PRICE_LIST',
          is_authorized: true,
          is_end_type: true,
          // is_end_type: false,
          isPreSetElement: true,
          id: 'price-list',
          parent_id: 'invoice',
          icon: 'certificate',
          pointingUrl: '/invoice/price-list',
        },
        {
          item_name: 'NAVBAR.PERIODIC_INVOICES_LIST',
          is_authorized: true,
          is_end_type: true,
          isPreSetElement: true,
          id: 'periodic-list',
          parent_id: 'invoice',
          icon: 'certificate',
          pointingUrl: '/invoice/periodic-list',
        },
        {
          item_name: 'NAVBAR.INTEGRITY_REPORT',
          is_authorized: true,
          is_end_type: true,
          isPreSetElement: true,
          id: 'integrity-report',
          parent_id: 'invoice',
          icon: 'certificate',
          pointingUrl: '/organization/integrity-report',
        },
      ]),
    },
  ];

  getPresetElements(): TreeNode[] {
    return this.presetTreeElements;
  }
}
